'use strict';

module.exports = function(
    $rootElement
) {

    return {
        // search categories and it's children recursively for matching categoryId
        // returns an array of category objects that includes the category with
        // the matching categoryId and all of its ancestors
        getAncestors: function(categories, categoryId) {
            var i;
            var catLength = categories.length;
            var current;
            var children;
            var childrenResult;

            for (i = 0; i < catLength; i++) {
                current = categories[i];
                children = current.children;

                // if current cat is a match, return it as an array
                if (categoryId === current.categoryId) {
                    return [current];

                // if no match, search its children
                } else if (children.length) {
                    // search children recursively
                    childrenResult = this.getAncestors(children, categoryId);

                    if (childrenResult && childrenResult.length) {
                        // combine current and children matches into array
                        return [current].concat( childrenResult );
                    }
                }
            }

            // if nothing found, return empty array
            return [];
        }
    };
};
